var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '../styled-components';
var Fieldset = styled.fieldset(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: none;\n  display: flex;\n  flex-direction: column;\n  margin: 10px 0;\n"], ["\n  border: none;\n  display: flex;\n  flex-direction: column;\n  margin: 10px 0;\n"])));
export default Fieldset;
var templateObject_1;
